export default "__VITE_ASSET__D3VgM4WU__"